import {AxiosRequestConfig} from 'axios';
import {IApiService} from './Interfaces/IApiService';
import ApiService from './ApiService';
import {IEidaService} from './Interfaces/IEidaService';
import {ILogService} from './Interfaces/ILogService';
import LogService from './LogService';

class EidaService implements IEidaService {
  apiService: IApiService;
  logService: ILogService;

  constructor(realmSignout: () => void) {
    this.apiService = new ApiService(realmSignout);
    this.logService = new LogService();
  }

  async getQC(request: {IncidentType: string; Description: string}) {
    let started = new Date().getTime();
    let ended = null;

    let config: AxiosRequestConfig = {};
    config.data = request;
    config.method = 'POST';
    config.url = process.env.REACT_APP_EIDA_QUALITY_CONTROL_URL;
    config.headers = {'Content-Type': 'application/json'};

    let qcResponse = null;

    try {
      let response = await this.apiService.sendRequest<any>(config);
      ended = new Date().getTime();

      if (
        response &&
        response.data &&
        response.data.status &&
        response.data.status == 'completed'
      )
        qcResponse = {
          status: response.data.status,
          followUpQuestions: response.data.follow_up_questions ?? [],
          time: ended - started,
          version: response.data.EIDA_version ?? null,
        };
    } catch (error: any) {
      //Custom error when server returns 500, that means Azure AI or OpenAI service is unavailable
      if (error?.response?.status == 500)
        qcResponse = {
          status: 'error',
          error: 'Analysis service temporarily offline, please try again',
          time: ended ? ended - started : undefined,
        };
      else if (error?.response?.status == 422)
        qcResponse = {
          status: 'error',
          error: 'Empty or invalid description - please try again',
          time: ended ? ended - started : undefined,
        };

      let logError = {
        type: 'EIDA Error',
        status: error?.response?.status || error?.status,
        msg: error.message,
        name: error.name,
        code: error.code,
        data: error?.config?.data,
      };

      this.logService.sendLog(JSON.stringify(logError));
    }

    return qcResponse;
  }

  async getAnalysis(request: {IncidentType: string; Description: string}) {
    let started = new Date().getTime();
    let ended = null;

    let config: AxiosRequestConfig = {};
    config.data = request;
    config.method = 'POST';
    config.url = process.env.REACT_APP_EIDA_ANALYSIS_URL;
    config.headers = {'Content-Type': 'application/json'};

    let analysisResponse: string | null = null;

    try {
      let response = await this.apiService.sendRequest<any>(config);
      ended = new Date().getTime();

      if (response && response.data)
        analysisResponse = JSON.stringify(response.data);
    } catch (error) {
      await this.logService.sendLog(JSON.stringify(error));
    }

    return {
      analysis: analysisResponse,
      time: ended ? ended - started : undefined,
    };
  }
}

export default EidaService;
